import { createEmptyDocumentFunctionRegistry } from '../../../documents/utils/functionRegistry';
import { DocumentFunctionRegistry } from '../../../documents/types';
import { SignOffBackground } from '../../../documents/form/views/cpt/SignOffBackground';
import { createCptActionHandlers } from './cptActionServices';
import {
    applyImplantConditionals,
    appendImplantConditionBlock,
    removeImplantConditionBlock,
    searchImplants,
} from './cptInputServices';
import { createImplantConditionsBlockExtension } from './cptRichTextExtensions';
import { cptViewHandlers } from './cptViewServices';

interface BuildCptDocumentFunctionsArgs {
    handleCopyNote?: () => Promise<void>;
    handlePreview?: () => void;
    handleSave?: () => Promise<void>;
    handleComplete?: (postAction?: any) => Promise<void>;
}

export const buildCptDocumentFunctions = ({
    handleCopyNote,
    handlePreview,
    handleSave,
    handleComplete,
}: BuildCptDocumentFunctionsArgs = {}): DocumentFunctionRegistry => {
    const base = createEmptyDocumentFunctionRegistry();
    return {
        ...base,
        actions: {
            ...base.actions,
            ...createCptActionHandlers({
                handleCopyNote,
                handlePreview,
                handleSave,
                handleComplete,
            }),
        },
        inputHandlers: {
            ...base.inputHandlers,
            implantConditionals: applyImplantConditionals,
        },
        repeaterHandlers: {
            ...base.repeaterHandlers,
            appendImplantConditionBlock,
            removeImplantConditionBlock,
        },
        viewHandlers: {
            ...base.viewHandlers,
            ...cptViewHandlers,
        },
        backgrounds: {
            ...base.backgrounds,
            SignOffBackground,
        },
        richTextExtensions: {
            ...base.richTextExtensions,
            implantConditionsBlock: createImplantConditionsBlockExtension,
        },
        searchProviders: {
            ...base.searchProviders,
            implantSuggestions: searchImplants,
        },
    };
};
